import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, Select, MenuItem, Typography, styled, useTheme, Box } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { ORDERED_BICS, bicToName } from '../utils/bicMappings';

const SelectorContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(4, 5, 6),

  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3, 4),
  },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
  '& .MuiInputBase-input': {
    padding: theme.spacing(3, 4),
  },
}));

interface Props {
  bic: Bic;
  onChange: (bic: Bic) => void;
}

export const PartnerBankSelector = ({ bic, onChange }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const handleOnChange = (event: any) => {
    onChange(event.target.value);
  };

  return (
    <SelectorContainer>
      <FormControl fullWidth>
        <Typography
          color="textSecondary"
          component="label"
          variant="body1"
          id="partner-bank-selector-label"
          sx={{ marginBottom: theme.spacing(2) }}
        >
          {t('cashbackCalculator.detailed.partnerBankSelector.label')}
        </Typography>
        <StyledSelect
          labelId="partner-bank-selector-label"
          id="partner-bank-selector"
          variant="outlined"
          value={bic}
          onChange={handleOnChange}
          MenuProps={{
            PaperProps: {
              sx: {
                boxShadow: '0px 2px 4px -1px rgba(30, 39, 50, 0.16)',
                borderRadius: '6px',
                backgroundColor: 'white',
              },
            },
          }}
          fullWidth
          inputProps={{ 'data-hj-whitelist': true }}
          IconComponent={(props) => (
            <Box
              display="flex"
              alignItems="center"
              sx={{
                marginTop: '-3px',
                '& svg': {
                  width: '22px',
                  height: '22px',
                  fill: theme.palette.text.primary,
                },
              }}
              {...props}
            >
              <ExpandMore />
            </Box>
          )}
        >
          {ORDERED_BICS.map((bic, index) => {
            return (
              <MenuItem value={bic} key={index}>
                {bicToName(bic)}
              </MenuItem>
            );
          })}
          <MenuItem value="OTHER_BANK" key="otherBank">
            {t('cashbackCalculator.detailed.partnerBankSelector.otherBank')}
          </MenuItem>
        </StyledSelect>
      </FormControl>
    </SelectorContainer>
  );
};
